import React, { useState } from "react";
import Commontooltip from "../../CommonTooltip/Commontooltip";
import { Tablenodatafound } from "../TableNoDataFount";
import classes from "../Table.module.css";
import styles from "../../../Components/Device/Device.module.css";

import replaceicon from "../../../Assests/Icons/replace.png";
import deleteimg from "../../../Assests/Images/delete.png";
import editimg from "../../../Assests/Images/pencil.png";
import reseticom from "../../../Assests/Icons/reset.png";
import {
  CheckUserType,
  MomentDate,
  getValidData,
} from "../../../Shared/Methods";
import CommonButton from "../../Buttons/CommonButton";
import historyicon from "../../../Assests/Icons/order-history.png";
import DeviceMeterHistoryModal from "../../../Modals/Device/DeviceMeterHistoryModal";
import { Col, Row } from "antd";
import ParameterListModal from "../../../Modals/Device/ParameterListModal";

interface props {
  Data: any;
  pageSize: number;
  pageind: number;
  GetList: () => void;
  setpageSize: any;
  setPageInd: any;
  OBJKeys: string[];
  OBJHead: string[];
  setShowresetvalueModal: any;
  setShowreplacemeterModal: any;
  setShowModal: any;
  setShowConfirmModal: any;
  setsubscribe: any;
}

function DeviceMeterTable({
  Data,
  pageSize,
  pageind,
  GetList,
  setpageSize,
  setPageInd,
  OBJKeys,
  OBJHead,
  setShowresetvalueModal,
  setShowreplacemeterModal,
  setShowModal,
  setShowConfirmModal,
  setsubscribe,
}: props) {
  const WithoutAction = OBJHead?.map((ele: any, ind: number) => {
    if (ele === "Action" && !CheckUserType()) {
      OBJHead.splice(ind, 1);
    }
  });
  const [showhistory, setShowHistory] = useState<any>({
    isView: false,
    item: {},
  });
  const [prameteropen, setParameteropen] = useState<any>({
    isView: false,
    item: [],
  });

  return (
    <>
      {prameteropen?.isView ? (
        <ParameterListModal
          open={prameteropen?.isView}
          closable={!prameteropen?.isView}
          onCancel={() => setParameteropen({ isView: false, item: [] })}
          Data={prameteropen.item}
        />
      ) : null}

      {showhistory?.isView ? (
        <DeviceMeterHistoryModal
          closable={!showhistory?.isView}
          open={showhistory?.isView}
          onCancel={() => setShowHistory({ isView: false, item: {} })}
          item={showhistory?.item}
        />
      ) : null}
      <tr>
        {OBJHead?.map((ele: any, ind) => (
          <th key={ind}>{ele}</th>
        ))}
      </tr>

      {Data?.length > 0 ? (
        Data?.map((ele: any, ind: number) => {
          // let parameterListdata = getValidData(
          //   ele?.parameter_list
          //     ? JSON.parse(ele?.parameter_list)?.map((data: any) => {
          //         for (const key in data) {
          //           return (
          //             <Col lg={8}>
          //               <p
          //                 style={{
          //                   fontSize: 12,
          //                   fontWeight: 600,
          //                   margin: 0,
          //                   textAlign: "center",
          //                 }}
          //               >
          //                 {[key]} :{" "}
          //                 <span
          //                   style={{
          //                     color: "grey",
          //                     fontSize: 11,
          //                     fontWeight: 600,
          //                     textAlign: "center",
          //                   }}
          //                 >
          //                   {data[key]}
          //                 </span>
          //               </p>
          //             </Col>
          //           );
          //         }
          //       })
          //     : ""
          // );

          return (
            <tr key={ind}>
              <td>{pageSize * pageind + (ind + 1)}</td>
              {OBJKeys?.map((val: any, index: number) => {
                return (
                  <td
                    key={index}
                    style={
                      val === "subscription_start" || val === "subscription_end"
                        ? { minWidth: "170px" }
                        : val === "meter_name"
                        ? { minWidth: 200, wordBreak: "break-word" }
                        : {}
                    }
                  >
                    {val === "subscription_start" ||
                    val === "subscription_end" ? (
                      getValidData(ele[val] ? MomentDate(ele[val]) : "")
                    ) : ele?.subscription_status === 0 &&
                      val === "subscription_status_name" ? (
                      <CommonButton
                        name="Subscribe"
                        type="button"
                        onClick={() =>
                          setsubscribe({ isView: true, item: ele })
                        }
                        classname="subscribe_btn"
                        style={{
                          padding: "4px 16px",
                          maxWidth: "93px",
                          height: "29px",
                          color: "white",
                        }}
                        disabled={!CheckUserType()}
                      />
                    ) : val === "parameter_list" ? (
                      <div
                        className={styles.parameter_list_icon_container}
                        style={{
                          margin: "auto",
                        }}
                        onClick={() =>
                          setParameteropen({
                            isView: true,
                            item: ele.parameter_list,
                          })
                        }
                      >
                        <p className={styles.icon_style}>!</p>
                      </div>
                    ) : val === "history" ? (
                      // <Commontooltip
                      //   children={
                      //     <img
                      //       src={historyicon}
                      //       alt="history"
                      //       style={{
                      //         width: "25px",
                      //         background: "transparent",
                      //         padding: "0",
                      //       }}
                      //       onClick={() =>
                      //         setShowHistory({ isView: true, item: ele })
                      //       }
                      //     />
                      //   }
                      //   msg="History"
                      // />
                      <img
                        src={historyicon}
                        alt="history"
                        style={{
                          width: "25px",
                          background: "transparent",
                          padding: "0",
                        }}
                        onClick={() =>
                          setShowHistory({ isView: true, item: ele })
                        }
                      />
                    ) : (
                      getValidData(ele?.[val])
                    )}
                  </td>
                );
              })}
              {CheckUserType() ? (
                <td>
                  <div
                    className={classes.action_container}
                    style={{
                      padding: 0,
                      background: "transparent",
                      justifyContent: "center",
                    }}
                  >
                    <Commontooltip
                      children={
                        <img
                          src={reseticom}
                          onClick={() => {
                            setShowresetvalueModal((pre: any) => {
                              return {
                                ...pre,
                                isView: true,
                                action: "Reset",
                                item: ele,
                              };
                            });
                          }}
                          style={{ width: "19px", height: "19px" }}
                          alt="editimg"
                        />
                      }
                      msg="Reset Value"
                    />
                    <Commontooltip
                      children={
                        <img
                          src={replaceicon}
                          onClick={() => {
                            setShowreplacemeterModal((pre: any) => {
                              return {
                                ...pre,
                                isView: true,
                                action: "Replace",
                                item: ele,
                              };
                            });
                          }}
                          style={{ width: "17px", height: "17px" }}
                          alt="editimg"
                        />
                      }
                      msg="Replace Meter"
                    />

                    <Commontooltip
                      children={
                        <img
                          src={editimg}
                          onClick={() => {
                            setShowModal((pre: any) => {
                              return {
                                ...pre,
                                isView: true,
                                action: "Update",
                                item: ele,
                              };
                            });
                          }}
                          alt="editimg"
                        />
                      }
                      msg="Update"
                    />
                    {/* <Commontooltip
                  children={
                    <img
                      src={reseticon}
                      onClick={() => {
                        setShowresetvalueModal((pre: any) => {
                          return {
                            ...pre,
                            isView: true,
                            action: "Reset",
                            item: ele,
                          };
                        });
                      }}
                      style={{ width: "19px", height: "19px" }}
                      alt="editimg"
                    />
                  }
                  msg="Reset Value"
                /> */}
                    <Commontooltip
                      children={
                        <img
                          src={deleteimg}
                          alt="deleteimg"
                          style={{ width: "18px", height: "18px" }}
                          onClick={() =>
                            setShowConfirmModal({
                              isView: true,
                              item: ele,
                            })
                          }
                        />
                      }
                      msg="Delete"
                    />
                  </div>
                </td>
              ) : null}
            </tr>
          );
        })
      ) : (
        <Tablenodatafound />
      )}
    </>
  );
}

export default DeviceMeterTable;
